import React from "react";
import BackButton from "./BackBtn";

function UpsertHeader({ navTo = "../list", headerTitle = "" }) {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center">
        <BackButton navTo={navTo} />

        <h4 className="card-title mb-0">{headerTitle}</h4>
      </div>

      <hr className="mt-2" />
    </React.Fragment>
  );
}

export default UpsertHeader;
